// extracted by mini-css-extract-plugin
module.exports = {"root":"PhoneNumber_root__3aX1f"};